import React, { useRef, useEffect } from 'react';
import { MdClose, MdEdit } from 'react-icons/md';

const EditPopup = ({ 
  showPopup, 
  setShowPopup, 
  popupPosition, 
  selectedText, 
  editPrompt, 
  setEditPrompt, 
  handleAIEdit, 
  isProcessing 
}) => {
  const popupRef = useRef(null);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
        setEditPrompt('');
      }
    };

    if (showPopup) {
      window.document.addEventListener('mousedown', handleClickOutside);
      return () => window.document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showPopup, setShowPopup, setEditPrompt]);

  if (!showPopup) return null;

  return (
    <div
      ref={popupRef}
      className="fixed z-50 bg-white border border-gray-200/60 rounded-xl shadow-xl p-5 min-w-80 backdrop-blur-sm"
      style={{
        left: popupPosition.x,
        top: popupPosition.y,
        maxWidth: '400px'
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium text-gray-900">Edit with AI</h3>
        <button
          onClick={() => {
            setShowPopup(false);
            setEditPrompt('');
          }}
          className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
        >
          <MdClose size={18} />
        </button>
      </div>
      
      <div className="mb-4">
        <div className="text-xs text-gray-500 mb-2 font-medium">Selected text</div>
        <div className="text-sm bg-gray-50/70 p-3 rounded-lg border border-gray-200/60 max-h-20 overflow-y-auto font-mono text-gray-700 leading-relaxed">
          {selectedText}
        </div>
      </div>
      
      <div className="mb-4">
        <input
          type="text"
          value={editPrompt}
          onChange={(e) => setEditPrompt(e.target.value)}
          placeholder="Describe how to edit this text..."
          className="w-full px-4 py-3 bg-gray-50/70 border border-gray-200/60 rounded-xl focus:outline-none focus:bg-white focus:ring-2 focus:ring-gray-900/20 transition-all duration-200 text-sm"
          onKeyPress={(e) => {
            if (e.key === 'Enter' && !isProcessing) {
              handleAIEdit();
            }
          }}
          autoFocus
        />
      </div>
      
      <div className="flex space-x-3">
        <button
          onClick={handleAIEdit}
          disabled={isProcessing || !editPrompt.trim()}
          className="flex-1 flex items-center justify-center space-x-2 px-4 py-3 bg-gray-900 text-white rounded-xl hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium transition-colors duration-200"
        >
          <MdEdit size={16} />
          <span>{isProcessing ? 'Processing...' : 'Edit with AI'}</span>
        </button>
        
        <button
          onClick={() => {
            setShowPopup(false);
            setEditPrompt('');
          }}
          className="px-4 py-3 text-gray-700 hover:text-gray-900 hover:bg-gray-100/60 rounded-xl text-sm font-medium transition-colors duration-200"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EditPopup;